import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const PatientAlertAction = {
  ...SurveyName,
  VIEW_PATIENT_PROFILE: 'VIEW_PATIENT_PROFILE',
} as const;

export type PatientAlertAction =
  (typeof PatientAlertAction)[keyof typeof PatientAlertAction];

export type PatientAlert = {
  action: PatientAlertAction;
  description: string;
  name?: string;
  responseExternalId?: string;
  surveyExternalId?: string;
  title?: string;
  updatedDate: string;
};
